document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('HeaderDrawerNewsletterForm');
  const successMessage = document.querySelector('.menu-drawer__newsletter-success');
  
  if (form && successMessage) {
    // Check if already subscribed this session
    if (sessionStorage.getItem('newsletter_subscribed') === 'true') {
      form.style.display = 'none';
      successMessage.classList.remove('hidden');
    }

    form.addEventListener('submit', () => {
      // The form natively submits to the hidden iframe because of target="newsletter_frame"
      // We just need to update the UI and save to session storage
      sessionStorage.setItem('newsletter_subscribed', 'true');
      
      // Add a tiny delay to ensure the form submission starts before we hide it
      setTimeout(() => {
        form.style.display = 'none';
        successMessage.classList.remove('hidden');
      }, 50);
    });
  }
});